import { createAction } from '@reduxjs/toolkit'
import { filesClear } from 'redux/action.types'
import filesReducer from './Files.reducer'

export const clearFilesState = createAction(filesClear)

export default filesReducer
